import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type BookingListElementBookingFragment = { __typename?: 'Booking', guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason?: Types.BookingCancelReason | null, summary?: string | null, assignedStaff: { __typename?: 'Staff', displayName: string } };

export const BookingListElementBookingFragmentDoc = gql`
    fragment BookingListElementBooking on Booking {
  guid
  startsAt
  endsAt
  cancelReason
  summary
  assignedStaff {
    displayName
  }
}
    `;